export const bodyLeftData = {
  agQRcode: {
    className: "agQRcode",
    title: "Scan to get AG app",
  },
  mostPopular: {
    className: "most-popular",
    title: "Fish Hunter",
  },
  casino: {
    className: "casino",
    title: "Casino",
    href: "/en/casino?p=ag"
  },
  slots: {
    className: "slots",
    title: "Slots",
    href: "/en/casino?p=ag"
  },
}

export const casinoRightMenuData2 = 
[
  {
    "id": "PROMOTION",
    "nameDisplay": "Promotions",
    "sequence": 1,
    "showOn": "Casino",
    "casinoData": null,
    "promotionData": [
      {
        "promotionId": 100541,
        "promotionCode": "bonus2",
        "promotionTitle": "Dota 2 Virtual Sniper 234",
        "promotionType": "DEPOSIT",
        "promotionCategoryId": 1,
        "promotionCategoryName": "Live Casino",
        "promotionDesc": "<p>Deposit - Soccer & 2 Ways Royal (Video Poker) Rebate on soccer and rollover on any sport</p>\n",
        "attachmentId": 4736,
        "name": "Promotion-Strategy-1.jpg|en_US",
        "imagePath": "",
        "bonusTrigger": "UPON_DEPOSIT",
        "depositCount": "DEPOSITOR",
        "affiliate": 0,
        "manualCredit": 0,
        "startDate": 1548126000000,
        "endDate": 1556679599000
      },
      {
        "promotionId": 100540,
        "promotionCode": "bonus1",
        "promotionTitle": "Devil May Cry 2 Special Edition",
        "promotionType": "DEPOSIT",
        "promotionCategoryId": 1,
        "promotionCategoryName": "Live Casino",
        "promotionDesc": "<p>Deposit - Soccer & 2 Ways Royal (Video Poker) Rebate on soccer and rollover on any sport</p>\n",
        "attachmentId": 4734,
        "name": "500_F_200924340_YlJaeatV4XquYjvck0N49kgscE0v1YPP.jpg|en_US",
        "imagePath": "",
        "bonusTrigger": "UPON_DEPOSIT",
        "depositCount": "DEPOSITOR",
        "affiliate": 0,
        "manualCredit": 0,
        "startDate": 1548126000000,
        "endDate": 1556679599000
      },
      {
        "promotionId": 100541,
        "promotionCode": "bonus2",
        "promotionTitle": "Packman Summer",
        "promotionType": "DEPOSIT",
        "promotionCategoryId": 1,
        "promotionCategoryName": "Live Casino",
        "promotionDesc": "<p>Deposit - Soccer & 2 Ways Royal (Video Poker) Rebate on soccer and rollover on any sport</p>\n",
        "attachmentId": 4732,
        "name": "special-promotion.png|en_US",
        "imagePath": "",
        "bonusTrigger": "UPON_DEPOSIT",
        "depositCount": "DEPOSITOR",
        "affiliate": 0,
        "manualCredit": 0,
        "startDate": 1548126000000,
        "endDate": 1556679599000
      },
      {
        "promotionId": 100541,
        "promotionCode": "bonus2",
        "promotionTitle": "Hot Summner 2019",
        "promotionType": "DEPOSIT",
        "promotionCategoryId": 1,
        "promotionCategoryName": "Live Casino",
        "promotionDesc": "<p>Deposit - Soccer & 2 Ways Royal (Video Poker) Rebate on soccer and rollover on any sport</p>\n",
        "attachmentId": 4730,
        "name": "Promotion-Strategy-1.jpg|en_US",
        "imagePath": "",
        "bonusTrigger": "UPON_DEPOSIT",
        "depositCount": "DEPOSITOR",
        "affiliate": 0,
        "manualCredit": 0,
        "startDate": 1548126000000,
        "endDate": 1556679599000
      },
      {
        "promotionId": 100541,
        "promotionCode": "bonus2",
        "promotionTitle": "Hot Summner 2019 Special VIP",
        "promotionType": "DEPOSIT",
        "promotionCategoryId": 1,
        "promotionCategoryName": "Live Casino",
        "promotionDesc": "<p>Deposit - Soccer & 2 Ways Royal (Video Poker) Rebate on soccer and rollover on any sport</p>\n",
        "attachmentId": 4730,
        "name": "Promotion-Strategy-1.jpg|en_US",
        "imagePath": "",
        "bonusTrigger": "UPON_DEPOSIT",
        "depositCount": "DEPOSITOR",
        "affiliate": 0,
        "manualCredit": 0,
        "startDate": 1548126000000,
        "endDate": 1556679599000
      }
    ]
  },
  {
    "id": "WINNINGRIGHTNOW",
    "nameDisplay": "Winning Right Now",
    "sequence": 2,
    "showOn": "Casino",
    "casinoData": [
      {
        "gameId": "5342",
        "gameName": "Cops And Robbers",
        "transactionId": 0,
        "transactionDate": 1547780400000,
        "userId": 20000001,
        "loginId": "SB",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 0.1478635,
        "stake": 0.1478635
      },
      {
        "gameId": "5342",
        "gameName": "Avalon",
        "transactionId": 0,
        "transactionDate": 1535631503000,
        "userId": 20000001,
        "loginId": "SB",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 2.9368440,
        "stake": 2.9368440
      },
      {
        "gameId": "5342",
        "gameName": "Aces and Faces Power Poker",
        "transactionId": 0,
        "transactionDate": 1535487350000,
        "userId": 20000001,
        "loginId": "SB",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 5.8665280,
        "stake": 5.8665280
      },
      {
        "gameId": "5396",
        "gameName": "15 Golden Eggs",
        "transactionId": 0,
        "transactionDate": 1535479815000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 12.5000000,
        "stake": 7.5000000
      },
      {
        "gameId": "5354",
        "gameName": "African Spirit",
        "transactionId": 0,
        "transactionDate": 1535400091000,
        "userId": 20000001,
        "loginId": "SB",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 1.4685800,
        "stake": 1.4685800
      }
    ],
    "promotionData": null
  },
  {
    "id": "MYLASTWINS",
    "nameDisplay": "My Last Wins",
    "sequence": 3,
    "showOn": "Casino",
    "casinoData": [
      {
        "gameId": "1071",
        "gameName": "Avalon",
        "transactionId": 0,
        "transactionDate": 1535632182000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 20.0000000,
        "stake": 20.0000000
      },
      {
        "gameId": "1071",
        "gameName": "Avalon",
        "transactionId": 0,
        "transactionDate": 1535632098000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 20.0000000,
        "stake": 20.0000000
      },
      {
        "gameId": "5354",
        "gameName": "African Spirit",
        "transactionId": 0,
        "transactionDate": 1535487542000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 5.0000000,
        "stake": 10.0000000
      },
      {
        "gameId": "5396",
        "gameName": "15 Golden Eggs",
        "transactionId": 0,
        "transactionDate": 1535479815000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 12.5000000,
        "stake": 7.5000000
      },
      {
        "gameId": "1736",
        "gameName": "108 Heroes",
        "transactionId": 0,
        "transactionDate": 1535479657000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 100.0000000,
        "stake": 750.0000000
      }
    ],
    "promotionData": null
  },
  {
    "id": "TOPWINNERS",
    "nameDisplay": "Top Winners",
    "sequence": 4,
    "showOn": "Casino",
    "casinoData": [
      {
        "gameId": "1771",
        "gameName": "Sicbo (Live Dealer)",
        "transactionId": 0,
        "transactionDate": 1534918218000,
        "userId": 1000026813,
        "loginId": "playertest1",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 5.0000000,
        "stake": 5.0000000
      },
      {
        "gameId": "1016",
        "gameName": "Bush Telegraph",
        "transactionId": 0,
        "transactionDate": 1530590400000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 1.8000000,
        "stake": 2.7000000
      },
      {
        "gameId": "1017",
        "gameName": "Cashanova",
        "transactionId": 0,
        "transactionDate": 1530244800000,
        "userId": 1000003939,
        "loginId": "kennguyen1",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 3.0000000,
        "stake": 3.0000000
      },
      {
        "gameId": "1019",
        "gameName": "Dino Might",
        "transactionId": 0,
        "transactionDate": 1530158400000,
        "userId": 1000004626,
        "loginId": "zaza111",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 25.8000000,
        "stake": 0.6000000
      },
      {
        "gameId": "1019",
        "gameName": "Dino Might",
        "transactionId": 0,
        "transactionDate": 1530158400000,
        "userId": 20000001,
        "loginId": "SB",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 0.0147837,
        "stake": 0.0147837
      }
    ],
    "promotionData": null
  },
  {
    "id": "RECENTLYPLAYED",
    "nameDisplay": "Recently Played",
    "sequence": 5,
    "showOn": "Casino",
    "casinoData": [
      {
        "gameId": "1071",
        "gameName": "Avalon",
        "transactionId": 0,
        "transactionDate": 1535631503000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": -20.0000000,
        "stake": 20.0000000
      },
      {
        "gameId": "1283",
        "gameName": "Aces and Faces Power Poker",
        "transactionId": 0,
        "transactionDate": 1535487350000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": -40.0000000,
        "stake": 40.0000000
      },
      {
        "gameId": "5396",
        "gameName": "15 Golden Eggs",
        "transactionId": 0,
        "transactionDate": 1535479815000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": 12.5000000,
        "stake": 7.5000000
      },
      {
        "gameId": "5354",
        "gameName": "African Spirit",
        "transactionId": 0,
        "transactionDate": 1535400091000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": -10.0000000,
        "stake": 10.0000000
      },
      {
        "gameId": "1198",
        "gameName": "Aces and Eights",
        "transactionId": 0,
        "transactionDate": 1535400038000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": -2.0000000,
        "stake": 2.0000000
      },
      {
        "gameId": "5398",
        "gameName": "12 Animals",
        "transactionId": 0,
        "transactionDate": 1535120882000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": -15.0000000,
        "stake": 15.0000000
      },
      {
        "gameId": "10430",
        "gameName": "40 Joker Staxx",
        "transactionId": 0,
        "transactionDate": 1535120242000,
        "userId": 1000004634,
        "loginId": "zaza333",
        "status": "SETTLED",
        "currencyCode": "CNY",
        "winLoss": -7.0000000,
        "stake": 7.0000000
      }
    ],
    "promotionData": null
  },
  {
    "id": "JACKPOTS",
    "nameDisplay": "Jackpots",
    "sequence": 6,
    "showOn": "Casino",
    "casinoData": [
      {
        "gameId": "2028",
        "gameName": "Treasure Room",
        "gameCode": "158",
        "transactionId": 0,
        "transactionDate": null,
        "userId": 0,
        "loginId": null,
        "status": null,
        "currencyCode": "CNY",
        "winLoss": 0,
        "stake": null
      },
      {
        "gameId": "2026",
        "gameName": "The Ghouls",
        "gameCode": "156",
        "transactionId": 0,
        "transactionDate": null,
        "userId": 0,
        "loginId": null,
        "status": null,
        "currencyCode": "CNY",
        "winLoss": 0,
        "stake": null
      },
      {
        "gameId": "2033",
        "gameName": "Glam Life",
        "gameCode": "173",
        "transactionId": 0,
        "transactionDate": null,
        "userId": 0,
        "loginId": null,
        "status": null,
        "currencyCode": "CNY",
        "winLoss": 0,
        "stake": null
      },
      {
        "gameId": "2031",
        "gameName": "Diamond Jackpot",
        "gameCode": "32",
        "transactionId": 0,
        "transactionDate": null,
        "userId": 0,
        "loginId": null,
        "status": null,
        "currencyCode": "CNY",
        "winLoss": 0,
        "stake": null
      },
      {
        "gameId": "2007",
        "gameName": "All American",
        "gameCode": "46",
        "transactionId": 0,
        "transactionDate": null,
        "userId": 0,
        "loginId": null,
        "status": null,
        "currencyCode": "CNY",
        "winLoss": 0,
        "stake": null
      }
    ],
    "promotionData": null
  }
]

export const casinoData = [
  {gameId: 1, name: "Warlords: Crystals of Power", className: "agin_agin", gameType: 2, isJackpot: true, jackpot: 123456789},
  {gameId: 2, name: "Lost Relics", className: "agin_aghh", gameType: 16, isNew: true},
  {gameId: 3, name: "Twin Spin Deluxe", className: "agin_agq", gameType: 1},
  {gameId: 4, name: "The Phantom's Curese Video", className: "agin_bid", gameType: 5},
  {gameId: 5, name: "VIP", className: "agin_vip", gameType: 4},
  {gameId: 6, name: "VIP", className: "agin_vip", gameType: 4},
  {gameId: 7, name: "VIP", className: "agin_vip", gameType: 4},
  {gameId: 8, name: "VIP", className: "agin_vip", gameType: 4},
  {gameId: 9, name: "VIP", className: "agin_vip", gameType: 4, isJackpot: true, jackpot: 123456789},
  {gameId: 10, name: "VIP", className: "agin_vip", gameType: 4},
  {gameId: 11, name: "VIP", className: "agin_vip", gameType: 4},
  {gameId: 12, name: "VIP", className: "agin_vip", gameType: 4}
];

export const category = {
  allGame: {
    id: 1,
    name: 'All Games'
  },
  newGames: {
    id: 3,
    name: 'New Games'
  },
};

export const category1 = {
  allGame: {
    id: 1,
    name: 'All Games'
  },
  slots: {
    id: 2,
    name: 'Slots',
    isSelected: true
  },
  newGames: {
    id: 3,
    name: 'New Games'
  },
  tableGames: {
    id: 4,
    name: 'Table Games'
  },
  jackpots: {
    id: 5,
    name: 'Jackpots'
  },
  videoPoker: {
    id: 6,
    name: 'Video Poker'
  }
};

export const subCategory = {
  allSlots: {
    id: 7,
    name: 'All Slots',
    isSelected: true
  },
  jackpotSlots: {
    id: 8,
    name: 'Jackpot Slots'
  },
  newSlots: {
    id: 9,
    name: 'New Slots'
  },
  classicSlots: {
    id: 10,
    name: 'Classic Slots'
  }
};


export const actions = {
  SELECT_MAIN_CATEGORY: 'SELECT_MAIN_CATEGORY',
  SELECT_SUB_CATEGORY: 'SELECT_SUB_CATEGORY',
  SELECT_PROVIDER: 'SELECT_PROVIDER',
  SELECT_MORE_GAMES: 'SELECT_MORE_GAMES',
  SEARCH_NAME: 'SEARCH_NAME',
  OPEN_SEARCH_BAR: 'OPEN_SEARCH_BAR',
  CLOSE_SEARCH_BAR: 'CLOSE_SEARCH_BAR',
  OPEN_FAVOURITE_GAMES: 'OPEN_FAVOURITE_GAMES',
  OPEN_CATEGOGY_FAVOURITES: 'OPEN_CATEGOGY_FAVOURITES',
  SELECT_PROVIDER_FAVOURITES: 'SELECT_PROVIDER_FAVOURITES'
};

export const defaultWallet = {
  productCode: -1,
  productName: 'Select Wallet',
};

export const casinoPage = {
	CASINO: 'casino',
	LIVE_CASINO: 'live-casino'
}



// WEBPACK FOOTER //
// ./src/app/components/CasinoComponent/constants.js